import dayjs from '@/helpers/dayjstz';
import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';
import { getSavedState } from '@/helpers/storageOperations';

export default server => {
    server.get('/v1/accounts', schema => {
        const { models } = schema.users.all();

        return models;
    });

    server.get('/v1/accounts/:id', (schema, { params: { id } }) => {
        const user = schema.users.find(id);
        const loggedUser = getSavedState('auth.currentUser');

        if (!loggedUser?.id) {
            return new Response(HTTP.UNAUTHORIZED);
        }

        if (!user) {
            return new Response(HTTP.NOT_FOUND);
        }

        return user.attrs;
    });

    server.post('/v1/team_member_invites', (schema, { requestBody }) => {
        const { role, email, team_ids = [] } = JSON.parse(requestBody);

        const {
            models: [user]
        } = schema.users.where(item => item.email === email);

        if (user) {
            return new Response(
                HTTP.UNPROCESSABLE_ENTITY,
                {},
                {
                    error_message: {
                        base: ['This email is already in use.']
                    }
                }
            );
        }

        const createdUser = schema.users.create({
            role,
            email,
            createdAt: dayjs()
        });

        const teamsModels = [];

        for (const teamId of team_ids) {
            const team = schema.teams.find(teamId);

            teamsModels.push(team);
        }

        createdUser.update({ teams: teamsModels });

        return new Response(HTTP.CREATED);
    });

    server.patch('/v1/accounts/:id', (schema, { params: { id }, requestBody }) => {
        const user = schema.users.find(id);

        if (!user) {
            return new Response(HTTP.NOT_FOUND);
        }

        const { role, teamIds = [] } = JSON.parse(requestBody);

        const teamsModels = [];

        for (const teamId of teamIds) {
            const team = schema.teams.find(teamId);

            teamsModels.push(team);
        }

        user.update({ role, teams: teamsModels });

        return user.attrs;
    });

    server.delete('/v1/accounts/:id', (schema, { params: { id } }) => {
        const user = schema.users.find(id);

        if (user) {
            user.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });
};
